import classNames from 'classnames';
import { Dropdown } from 'flowbite-react';
import React from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useUserContext } from 'src/context/UserProvider';
import { PositionStatus } from 'types';

interface Props {
	positionId: string;
	isBlacklisted?: boolean;
	positionStatus: PositionStatus;
	handleClosePosition: () => void;
	handleViewPosition: (id: string) => void;
	customStyleClass?: string;
	handleEditPosition?: (id: string) => void;
	handleReopenPosition: (id: string) => void;
	handleDuplicatePosition?: (id: string) => void;
	handleAddCollaborator: (id: string) => void;
	handleUpdatePositionExpiry: (id: string) => void;
	handleUpdateApplicationExpiry?: (id: string) => void;
	handleUpdateAutoRecommendationExpiry?: (id: string) => void;
}

const RecruiterPositionCardMoreOptions = ({
	positionId,
	isBlacklisted,
	positionStatus,
	handleClosePosition,
	handleViewPosition,
	handleDuplicatePosition,
	customStyleClass,
	handleEditPosition,
	handleAddCollaborator,
	handleUpdatePositionExpiry,
	handleUpdateApplicationExpiry,
	handleUpdateAutoRecommendationExpiry,
	handleReopenPosition,
}: Props) => {
	const { isAccountManagerLoggedIn } = useUserContext();
	return (
		<>
			<div className={classNames(customStyleClass, "[&_div[data-testid='flowbite-dropdown']]:!border-gray-200 ")}>
				<Dropdown
					inline={true}
					arrowIcon={false}
					placement="bottom-end"
					color={'#C7C9D9'}
					className="dark:!bg-[#111E2C] !text-[#E4E4EB] w-[224px] rounded-[8px]"
					label={<BsThreeDotsVertical className="w-[24px] h-[24px]" />}
					dismissOnClick
				>
					<Dropdown.Item
						onClick={() => handleViewPosition(positionId)}
						className={
							'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
						}
					>
						View Details
					</Dropdown.Item>
					{handleDuplicatePosition ? (
						<Dropdown.Item
							disabled={isBlacklisted}
							onClick={() => (isBlacklisted ? false : handleDuplicatePosition(positionId))}
							className={
								'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
							}
						>
							Duplicate Position
						</Dropdown.Item>
					) : null}
					{positionStatus === PositionStatus.OPEN ? (
						<>
							{handleEditPosition ? (
								<Dropdown.Item
									onClick={() => handleEditPosition(positionId)}
									className={
										'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
									}
								>
									Edit Position
								</Dropdown.Item>
							) : null}
							<Dropdown.Item
								onClick={() => handleAddCollaborator(positionId)}
								className={
									'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
								}
							>
								Invite Collaborator
							</Dropdown.Item>
							{isAccountManagerLoggedIn ? (
								<>
								<Dropdown.Item
									onClick={() => handleUpdatePositionExpiry(positionId)}
									className={
										'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
									}
								>
									Update Expiry
								</Dropdown.Item>
									{handleUpdateApplicationExpiry ? (
										<Dropdown.Item
											onClick={() => handleUpdateApplicationExpiry(positionId)}
											className={
												'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
											}
										>
											Update Application Expiry
										</Dropdown.Item>
									) : null}
									{handleUpdateAutoRecommendationExpiry ? (
										<Dropdown.Item
											onClick={() => handleUpdateAutoRecommendationExpiry(positionId)}
											className={
												'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
											}
										>
											Update Auto Recommendation Expiry
										</Dropdown.Item>
									) : null}
								</>
							) : null}
							<Dropdown.Item
								onClick={handleClosePosition}
								className={
									'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
								}
							>
								Close Position
							</Dropdown.Item>
						</>
					) : (
						<>
							<Dropdown.Item
								onClick={() => handleReopenPosition(positionId)}
								className={
									'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
								}
							>
								Reopen Position
							</Dropdown.Item>
						</>
					)}
				</Dropdown>
			</div>
		</>
	);
};

export default RecruiterPositionCardMoreOptions;
